import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-landing-model',
  templateUrl: './landing-model.component.html',
  styleUrls: ['./landing-model.component.css']
})
export class LandingModelComponent implements OnInit {

  constructor( private activeModal: NgbActiveModal,) { 
  }

  ngOnInit() {
  }

  closeModal(){
    this.activeModal.dismiss('cancel click');
  }

}
